module.exports = __webpack_public_path__ + "static/media/introducaoAoWooCommerce.61c3ae5f.png";